import { ProbableIncident } from '@mobile/ActionQueue/Actions/Incidents/ProbableIncident'
import { IncidentDetailsFillState } from '@mobile/views/Relation/DetailsPanel/enums'

import { getIncidentAttributesDetailsFillState } from '../../../Modals/utils'
import { isZoneAttributeSelected } from '../components/FieldZonesModal/utils'
import { groups, zones } from './consts'

export function getIncidentDetailsFillState(incident: ProbableIncident): {
  state: IncidentDetailsFillState
} {
  const states = [
    isZoneAttributeSelected(incident.attribute_ids, Array.from(zones.values()))
      ? IncidentDetailsFillState.Filled
      : IncidentDetailsFillState.NotFilled,
    getIncidentAttributesDetailsFillState(groups, incident),
  ]

  if (states.every((s) => s === IncidentDetailsFillState.Filled)) {
    return { state: IncidentDetailsFillState.Filled }
  }

  if (states.every((s) => s === IncidentDetailsFillState.NotFilled)) {
    return { state: IncidentDetailsFillState.NotFilled }
  }

  return { state: IncidentDetailsFillState.HalfFilled }
}
